//include 7

// this has been taken from pixel3/typo3_base, it might be better to include it globally outside the scope of this crappy build suite
(function(w){
	w.pixel3A11y = {};
	w.pixel3A11y.focusableElements = [
		'[tabindex]',
		'[contenteditable=""]',
		'[contenteditable="true"]',
		'a[href]',
		'area[href]',
		'audio',
		'button',
		'embed',
		'form',
		'iframe',
		'input:not([type="hidden"])',
		'label',
		'link',
		'object',
		'select',
		'summary',
		'textarea',
		'video'
	].join(',');
	w.pixel3A11y.toggleTabIndex = function(dis, en = []) {
		dis.forEach(e => {
			const els = Array.from(e.querySelectorAll(w.pixel3A11y.focusableElements));
			if (e.matches(w.pixel3A11y.focusableElements)) {
				els.push(e);
			}
			els.forEach(el => {
				if (!el.hasAttribute('data-internal-tab-index')) {
					el.setAttribute('data-internal-tab-index', el.tabIndex);
				}
				el.tabIndex = '-1';
			});
		});
		en.forEach(e => {
			const els = Array.from(e.querySelectorAll('[data-internal-tab-index]'));
			if (e.hasAttribute('data-internal-tab-index')) {
				els.push(e);
			}
			els.forEach(el => {
				el.tabIndex = el.getAttribute('data-internal-tab-index');
			});
		});
	};
})(window);

jQuery(function () {

	// use an observer to automatically toggle the tabindex whenever the aria-expanded attribute on a main-level link changes
	const tabIndexObserver = new MutationObserver(function (mutations) {
		const disable = [];
		const enable = [];
		mutations.forEach(mutation => {
			if (mutation.target.getAttribute('aria-expanded') === 'false') {
				disable.push(mutation.target.parentElement.querySelector('.supermenu'));
			} else {
				enable.push(mutation.target.parentElement.querySelector('.supermenu'));
			}
		});
		window.pixel3A11y.toggleTabIndex(disable, enable);
	});
	const mainLevelLinks = Array.from(document.querySelectorAll('.main-nav .menu-level-1 > a[aria-expanded]'));
	const mainLevelLinksWithSupermenu = mainLevelLinks.filter(link => {
		return link.closest('.menu-level-1').querySelector('.supermenu') !== null;
	});
	mainLevelLinksWithSupermenu.forEach(mainLevelLink => {
		tabIndexObserver.observe(mainLevelLink, {
			attributes: true,
			attributeFilter: ['aria-expanded'],
		});
	});
	// invoke tabindex toggle once statically to assure a correct initial dom state
	window.pixel3A11y.toggleTabIndex(mainLevelLinksWithSupermenu.map(link => link.parentElement.querySelector('.supermenu')));

	var clickEventType = ((document.ontouchstart !== null) ? 'click' : 'touchstart');

    $("#offCanvas .mobile-nav").on(clickEventType,".menu-level-1 > i, .menu-level-1 > a",function(e){
        var $this = $(this).closest(".menu-level-1");
        var secondClick = $this.hasClass('active');

		if ($(e.target) == $this.closest(".menu-level-1").find("> i") || $(e.target) == $this.closest(".menu-level-1").find("> a")) {
			alert("here 2");
		}

		$this.find('> a').click(function (e) {
			e.preventDefault();
		});

		var target = $(e.target);

		if (!secondClick) {
			// remove active class from each other li's
			if ($('#offCanvas .mobile-nav .menu-level-1.active').length > 0) {
				$('#offCanvas .mobile-nav .menu-level-1').each(function () {
					if ($(this).hasClass('active')) {
						$(this).removeClass('active');
					}
				});
			}
			// END

			$this.toggleClass('active');

			/*
            setTimeout(function(){

            	//var scrollTo = $("#offCanvas.is-open").offset().top - $("#offCanvas .mobile-nav .menu-level-1.active").offset().top;
            	//var scrollTo = $("#offCanvas .mobile-nav .menu-level-1.active").offset().top - $("#offCanvas.is-open").height();
            	var scrollTo = $("#offCanvas.is-open").offset().top - $("#offCanvas .mobile-nav .menu-level-1.active").offset().top;

            	console.log("OffCanvas Height " + $("#offCanvas.is-open").height());
            	console.log("OffCanvas Offset Top " + $("#offCanvas.is-open").offset().top);
            	console.log("Menu Item Height " + $("#offCanvas .mobile-nav .menu-level-1.active").height());
            	console.log("Menu Item Offset Top " + $("#offCanvas .mobile-nav .menu-level-1.active").offset().top);
            	console.log("ScrollTo " + scrollTo);
            	console.log("-----");

                $("#offCanvas.is-open").animate({scrollTop: scrollTo}, 800);
			}, 500);
			*/
		} else {
			// trigger link on secondClick
			if (target.closest('a').length) {
				var href = e.target.href;
				var linkTarget = e.target.target;

				if (linkTarget == "_blank") {
					window.open(href, linkTarget);
				} else {
					window.location = href;
				}
			}

			if (target.closest('i.icon-right-open-big').length) {
				$this.removeClass('active');
			}
			// END
		}
	});

	setMenuClickEvent();
	menuListingHeight();

	$(window).on("orientationchange resize", function () {
		setMenuClickEvent();
		menuListingHeight();
	});

	$('.supermenu > .close').click(function (e) {
		var supermenu = $(this).parents('.supermenu:first');
		// supermenu.addClass('collapsed'); // hide
		$('.menu-level-1').removeClass('hover');
		$('.menu-level-1').removeClass('open-menu');

		$('.menu-level-1 > a').attr("aria-expanded", 'false');

		supermenu.removeClass('hover'); // hide
		//supermenu.css('display','none'); // remove class for regular use
		supermenu.removeAttr("style");

		/*
		setTimeout(function(){
			// supermenu.removeClass('collapsed'); // remove class for regular use
			supermenu.css('display','block'); // remove class for regular use
		}, 400);
		*/
	});
});


$(document).ready(function () {
    headerOptions();

	$(".supersection").on("mouseover touchstart", function () {
		var $supersectionUl = $(this).parent();
		$supersectionUl.find(".supersection").removeClass("hover");

		$supersectionUl.find(".supersection > a[aria-expanded]").attr("aria-expanded", "false");

		$(this).addClass("hover");
		$(this).find("[aria-expanded='false']").attr("aria-expanded", "true");

		// @todo this might be removed, i cant find any place where .lazymenu is used
		$(this).find('.lazymenus').Lazy({
			bind: "event",
			delay: 0,
			onError: function (element) {
				element.trigger("error");
			},
			afterLoad: function (element) {
				if (element.parent().hasClass("center-cropped")) {
					var imageSrc = element.attr('src');
					element.parent().css("background-image", `url(${imageSrc})`);
				}
			},
		});
	});
	$(".supersection > a[aria-expanded]").on('keydown', function(e) {
		if (e.key !== "Enter") {
			// not our concern
			return;
		}
		if (this.getAttribute('aria-expanded') === 'true') {
			// already opened: default behaviour - follow link
			return;
		}
		// custom behaviour - open next level
		e.preventDefault();
		$(this).closest('.supersection').trigger('mouseover');
	});
	$(".supersection a").on("touchstart", function (e) {
		e.preventDefault();
		var supersection = $(e.target).closest(".supersection");
		var childContainer = supersection.find(">div.container");
		if (supersection.hasClass("hover") || childContainer.length == 0) {
			var a = $(e.target).closest("a");
			var href = a.attr("href");

			if (!!href && href.charAt(0) != "/")
				href = "/" + href;

			if (!!href)
				window.location.href = href;
		}
	});

	// @todo this is not okay, the correct should be generated in the backend
	$(document).on('click', '.region-map svg g path', function (e) {
		if (!!($(this).parent().attr("class")) && ($(this).parent().attr("class").split(" ")[2] == "region")) {
			var pageid = $(this).parent().attr("class").split(" ")[0];

			if (!!($(this).closest(".content").find("[data-page-uid='" + pageid + "']"))) {
				var pagelink = $(this).closest(".content").find("[data-page-uid='" + pageid + "']").attr('href');

				if (pagelink != "undefined" && pagelink != '' && typeof pagelink != 'undefined') {
					if (pagelink.charAt(0) != '/') {
						pagelink = "/" + pagelink;						
					}
					var newLink = window.location.protocol + "//" + window.location.host;
					newLink = newLink + pagelink.replace(newLink,"");
					window.location.replace(newLink);
				} else {
					window.location.href = "/index.php?id=" + pageid;
				}
			} else {
				window.location.href = "/index.php?id=" + pageid;
			}
		}
	});

	$(document).on('mouseenter', '.region-map svg g path', function (e) {
		if (!!$(this).parent().attr("class") && ($(this).parent().attr("class").split(" ")[2]) == "region") {
			$(".regionlisting li ." + $(this).parent().attr("class").split(" ")[0]).css('color', '#7ACDF3');

			var newTitle = $(".regionlisting li ." + $(this).parent().attr("class").split(" ")[0]).attr("title");
			var regionMap = $(this).closest("figure.region-map");
			regionMap.data("old-title",regionMap.attr("title")).attr("title",newTitle);
		}
	});
	$(document).on('mouseleave', '.region-map svg g path', function (e) {
		if (!!$(this).parent().attr("class") && ($(this).parent().attr("class").split(" ")[2]) == "region") {
			$(".regionlisting li ." + $(this).parent().attr("class").split(" ")[0]).css('color', 'inherit');
			//var regionMap = $(this).closest("figure.region-map");
			//regionMap.attr("title", regionMap.data("old-title"));
		}
	});

	$(".regionlisting li a").mouseenter(function (e) { 
		$("svg ." + $(this).attr("class") + " path").addClass('svghover');
	});

	$(".regionlisting li a").mouseleave(function (e) {
		$("svg ." + $(this).attr("class") + " path").removeClass('svghover');
	});

	$(".ortelisting li a").mouseenter(function (e) {
		$("svg ." + $(this).attr("class")).show();
	});

	$(".ortelisting li a").mouseleave(function (e) {
		$("svg ." + $(this).attr("class")).hide();
	});
});


function headerOptions(){
	$(".header-wrapper .header").css("position", "fixed");
    var $headerRow = $(".header-wrapper .header .header-row");

	$(".header-wrapper").css("padding-bottom", $(".header-wrapper .header").height());

    if($headerRow.hasClass("layout-2")){
		$(".header-wrapper").css("padding-bottom", $(".header-wrapper .header").height() - 1);

        var iScrollPos = 0;
        var scrolled = false;
        $(window).scroll(function() {
            scrolled = true;
        });

        setInterval(function() {
            if (scrolled) {
                scrolled = false;

                if (Foundation.MediaQuery.current != "large") {
                    var headerRowHeight = $headerRow.height();
                    var iCurScrollPos = $(this).scrollTop();

                    if (iCurScrollPos > iScrollPos) {
                        // scroll down
                        if (iCurScrollPos > headerRowHeight) {
                            $headerRow.addClass("scrolling");
                        }
                    } else {
                        // scroll up
                        if(iCurScrollPos < headerRowHeight){
                            $headerRow.removeClass("scrolling");
                            $(".header-wrapper").css("padding-bottom", $(".header-wrapper .header").height() - 1);
                        }
                    }
                    iScrollPos = iCurScrollPos;
                } else {
                    $headerRow.removeClass("scrolling");
                }
            }
        }, 100);
	}

    $(window).on("orientationchange resize", function () {
		if($headerRow.hasClass("layout-2")){
			$(".header-wrapper").css("padding-bottom", $(".header-wrapper .header").height() - 1);
		}
		else {
			$(".header-wrapper").css("padding-bottom", $(".header-wrapper .header").height());
		}
    });
}


function setMenuClickEvent() {
	if (!$(".header button.control.hamburger").is(":visible")) {
		var windowHeight = $(window).height();
		var navHeight = $(".header-wrapper > .header").height();
		var supermenuHeight = windowHeight - navHeight;

		$('.main-nav .menu-level-1 > a').off("click touchstart").on("click touchstart", function (e) {
			if ($(this).parent().find(".supermenu").length > 0) {
				e.preventDefault();

				var menuClicked = $('.main-nav').data("menu-clicked") || false;

				if (!menuClicked) {
					var getMenuSvgPath = function (name) {
						return getComputedStyle(document.documentElement).getPropertyValue("--svg-" + name).trim().replace(/^["']|["']$/g, "");
					};
					$.get(getMenuSvgPath("ausflugsregionen"), function (data) {
						$("#ausflugsregionen").html(new XMLSerializer().serializeToString(data.documentElement));
					});
					$.get(getMenuSvgPath("urlaubsregionen"), function (data) {
						$("#urlaubsregionen").html(new XMLSerializer().serializeToString(data.documentElement));
					});
					$.get(getMenuSvgPath("toporte"), function (data) {
						$("#toporte").html(new XMLSerializer().serializeToString(data.documentElement));
					});
					$.get(getMenuSvgPath("wasserreviere"), function (data) {
						$("#wasserreviere").html(new XMLSerializer().serializeToString(data.documentElement));
					});
					$.get(getMenuSvgPath("nationalenaturlandschaften"), function (data) {
						$("#nationalenaturlandschaften").html(new XMLSerializer().serializeToString(data.documentElement));
					});
					$('.main-nav').data("menu-clicked", true);
				}

				var $thisLinkItem = $(this);
				var $thisListItem = $(this).parent();

				$('.main-nav .menu-level-1 > a[aria-expanded]').attr("aria-expanded", "false");
				$thisLinkItem.attr("aria-expanded", "true");

				if ($thisListItem.hasClass("open-menu")) {
					var link = $(this);
					var target = link.attr("target");

					var href = $thisLinkItem.attr("href");
					if (!!href && href.charAt(0) != "/")
						href = "/" + href;

					if ($.trim(target).length > 0) {
						window.open(href, target);
					} else {
						window.location = href; //$thisLinkItem.attr("href");
					}
				} else {
					$('.main-nav .menu-level-1').removeClass("open-menu hover");
					$('.main-nav .menu-level-1 .supermenu').removeClass("hover");
					$('.main-nav .menu-level-1 .supermenu').css("min-height", "0");
					$('.main-nav .menu-level-1 .supermenu .supersection').removeClass("hover");
					$('.main-nav .menu-level-1 .supermenu .supersection > a[aria-expanded]').attr("aria-expanded", "false");

					$thisListItem.addClass("open-menu hover");
					$thisListItem.find(".supermenu").addClass("hover");

					if ($thisListItem.hasClass("only-thumbnails-menu")) {
						// @todo this might be removed, not mention of lazymenu in sourcecode
						$thisListItem.find('.lazymenus').Lazy({
							bind: "event",
							delay: 0,
							onError: function (element) {
								element.trigger("error");
							},
							afterLoad: function (element) {
								if (element.parent().hasClass("center-cropped")) {
									var imageSrc = element.attr('src');
									element.parent().css("background-image", `url(${imageSrc})`);
								}
							},
						});
					} else {
						var $menuSuperRowUl = $thisListItem.find('.supermenu > .super-row > ul');
						var tallestSuperRowUl = 0;

						$menuSuperRowUl.each(function () {
							var thisHeight = $(this).outerHeight(true);

							if (thisHeight > tallestSuperRowUl) {
								tallestSuperRowUl = thisHeight;
							}
						});

						var $menuElem = $thisListItem.find('.supermenu > .super-row > ul > li.supersection > .container .content');
						var tallestSupersectionContent = 0;

						$menuElem.each(function () {
							var thisHeight = $(this).outerHeight(true);
							if (thisHeight > tallestSupersectionContent) {
								tallestSupersectionContent = thisHeight;
							}
						});

						var supermenuPadding = $thisListItem.find(".supermenu").outerHeight(true) - $thisListItem.find(".supermenu").height();
						var listItemSupermenuMinHeight = "";


						if (supermenuHeight < (supermenuPadding + tallestSupersectionContent)) {
							if (supermenuHeight > tallestSuperRowUl) {
								listItemSupermenuMinHeight = supermenuHeight;
							} else {
								listItemSupermenuMinHeight = tallestSuperRowUl;
							}
						} else {
							if ((supermenuPadding + tallestSupersectionContent) > (supermenuPadding + tallestSuperRowUl)) {
								listItemSupermenuMinHeight = supermenuPadding + tallestSupersectionContent;
							} else {
								listItemSupermenuMinHeight = supermenuPadding + tallestSuperRowUl;
							}
						}

						listItemSupermenuMinHeight = listItemSupermenuMinHeight + 30; // 30 = padding-top
						$thisListItem.find(".supermenu").css("min-height", listItemSupermenuMinHeight + "px");
						$thisListItem.find(".supermenu .supersection").first().addClass("hover");

						var $parentMenuElem = $thisListItem.find('.supermenu > .super-row > ul');
						var parentMenuElemHeight = $parentMenuElem.height();
						$parentMenuElem.find('li.supersection > .container .content > ul').css("min-height", parentMenuElemHeight);
					}
				}
			}
			// @todo this might be removed, no mention of lazymenu in source code
			$('.supermenu .supersection.hover .lazymenus').Lazy({
				bind: "event",
				delay: 0,
				onError: function (element) {
					element.trigger("error");
				},
				afterLoad: function (element) {
					if (element.parent().hasClass("center-cropped")) {
						var imageSrc = element.attr('src');
						element.parent().css("background-image", `url(${imageSrc})`);
					}
				},
			});
		});

		// close supermenus when the user clicked outside the menu or esc is pressed with opened menu
		$(document).on('closemainmenu', function() {
			$('.supermenu.hover > .close').click();
		});
		if (!$(document).data("menu-close-click-initialised")) {
			$(document).on('click', function(e) {
				if (!e.target.matches('.main-nav .menu-level-1 > a[aria-expanded]') && !e.target.closest('.supermenu')) {
					$(document).trigger("closemainmenu");
				}
			});
			$(document).on('keydown', function(e) {
				if (e.key === "Escape") {
					$(document).trigger("closemainmenu");
				}
			});
			$(document).data('menu-close-click-initialised', true);
		}
	} else {
		$('.main-nav .menu-level-1').removeClass("open-menu hover");
		$('.main-nav .menu-level-1 .supermenu').removeClass("hover");
		$('.main-nav .menu-level-1 .supermenu').css("min-height", "0");
		$('.main-nav .menu-level-1 .supermenu .supersection').removeClass("hover");
		$('.main-nav .menu-level-1 .supermenu .supersection > a[aria-expanded]').attr("aria-expanded", "false");
	}
}

function menuListingHeight() {
	$('.main-nav > ul > li.menu-level-1 > .supermenu > .super-row > ul > li.supersection > .container .content .columns.large-4.listing').height('auto');
}